export function upsertMeta(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}
export function upsertOgMeta(property, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}
export function upsertCanonical(href) {
  if (!href) return;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}
export function applyPageSeo({ title, description, canonicalUrl, image }) {
  if (title) document.title = title;
  upsertMeta("description", description);
  upsertCanonical(canonicalUrl);
  upsertOgMeta("og:title", title);
  upsertOgMeta("og:description", description);
  upsertOgMeta("og:url", canonicalUrl);
  if (image) upsertOgMeta("og:image", image);
}